import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const WrestlingIcon = observer('WrestlingIcon', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='#061A32'
            className={className}
            onClick={onClick}
        >
            <path
                d='M16.4609 19.787C16.3363 21.0893 14.5517 21.2465 14.365 19.787L14.5517 14.645C14.6347 14.1931 14.7501 13.9834 15.1743 13.7468L17.2909 12.9385C17.7433 12.5878 17.8622 12.2863 17.8719 11.5913L17.3532 9.34586C17.6644 8.73764 17.7231 8.34834 17.4154 7.48218L20.7149 11.232C20.8845 11.4883 20.929 11.6437 20.8809 11.9505L20.2169 15.2737L21.96 19.4052C22.2505 20.5953 20.8601 21.3138 20.0923 20.3932L18.0587 15.5207L18.1625 14.6674L16.6269 15.4982L16.4609 19.787Z'
                fill='fill'
            />
            <path
                d='M17.1457 11.6137V9.59285C16.7261 10.0372 16.2512 10.1372 15.361 10.2889V10.8503L12.0408 12.0852C11.0447 12.6017 11.6465 14.2408 12.6219 13.8816L16.6684 12.3547C16.9935 12.1573 17.0898 11.9896 17.1457 11.6137Z'
                fill='fill'
            />
            <path
                d='M3.82194 20.7111C2.68081 21.5616 1.51894 20.3754 2.20362 19.2115L8.60831 7.16247C9.29339 6.35889 9.92272 6.47919 11.0565 7.31914H10.1851L13.2973 8.08011L15.9647 7.45343C16.9281 7.45343 17.2393 8.75155 16.4094 9.24394L13.2973 9.96014L9.72868 9.17679C11.3253 9.93322 12.8451 10.8016 13.3595 10.7882L13.3365 10.7952C12.1677 11.1489 11.5054 11.3493 11.0773 11.9297L10.4134 11.0568L9.45896 12.9369L12.1562 14.7497C12.5299 15.0124 12.694 15.2052 12.7786 15.7569L12.8408 19.7408C12.6541 21.1732 10.9735 21.1956 10.7038 19.7408L10.6831 16.4507L7.32196 14.1678L3.82194 20.7111Z'
                fill='fill'
            />
            <path
                d='M11.1475 3C11.9369 3 12.6007 3.53048 12.794 4.25027C13.1057 3.91094 13.5556 3.69785 14.0559 3.69785C14.9967 3.69785 15.7593 4.45138 15.7593 5.38091C15.7593 6.31044 14.9967 7.06397 14.0559 7.06397C13.2665 7.06397 12.6026 6.53347 12.4093 5.81366C12.0977 6.15299 11.6478 6.36611 11.1475 6.36611C10.2067 6.36611 9.44404 5.61258 9.44404 4.68306C9.44404 3.75353 10.2067 3 11.1475 3Z'
                fill='fill'
            />
        </SvgElement>
    );
});
